export default "__VITE_ASSET__DhFzN0y5__"